module.exports = __webpack_public_path__ + "fonts/Inter-700-latin-ext48.1ad231a.woff2";